import Relation from '../common/relation'

const state = Object.assign({}, Relation.state)
state.endpointParent = 'group'
state.endpointChild = 'account'

export default {
  namespaced: true,
  state,
  getters: Relation.getters,
  mutations: Relation.mutations,
  actions: Relation.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/groups/groupsAccount.js